import { RoleEnum } from '@/types/enums/role.enum';
import type { RouteManagerInterface } from '../route/routeManager';
import { AdminRole } from './factories/admin';
import { CustomerRole } from './factories/customer';
import { TechnicianRole } from './factories/technician';
import type { Role } from './role';

export class RoleTypeManager {
    public routeManager: RouteManagerInterface;

    public constructor(routeManager: RouteManagerInterface) {
        this.routeManager = routeManager;
    }

    public create(role: string): null | Role {
        switch (role) {
            case RoleEnum.ADMIN:
                return new AdminRole(this.routeManager);

            case RoleEnum.CUSTOMER:
                return new CustomerRole(this.routeManager);

            case RoleEnum.KTV:
                return new TechnicianRole(this.routeManager);

            default:
                return new TechnicianRole(this.routeManager);
        }
    }
}
